const uploadImageToServer = async (file, type = "evidence") => {
  const endpoint = `https://regulatoryreformfiresafety.seitechinternational.com/api/upload?type=${type}`;

  // Prepare form data
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      body: formData,
    });

    // Response is not OK (status not in 200–299)
    if (!response.ok) {
      const contentType = response.headers.get("Content-Type") || "";
      let errorMessage = `Server error (${response.status})`;

      if (contentType.includes("application/json")) {
        const json = await response.json();
        errorMessage = json.error || errorMessage;
      } else {
        const text = await response.text();
        if (text) errorMessage = text;
      }

      throw new Error(`Upload failed: ${errorMessage}`);
    }

    const data = await response.json();

    if (!data || !data.url) {
      throw new Error("Invalid response: Missing file URL");
    }

    return data; // should be { url: "/uploads/evidence/..." }
  } catch (err) {
    // Client-side or unexpected errors
    let message = "Image upload failed. ";

    if (err instanceof TypeError && err.message.includes("fetch")) {
      message += "Could not reach the server. Please check your connection.";
    } else {
      message += err.message;
    }

    console.error("uploadImageToServer error:", {
      endpoint,
      fileName: file?.name,
      fileType: file?.type,
      fileSize: file?.size,
      error: err,
    });

    throw new Error(message);
  }
};

export default uploadImageToServer;
